import { render, staticRenderFns } from "./ReviewCategoryTag.vue?vue&type=template&id=18bc4e7c"
import script from "./ReviewCategoryTag.vue?vue&type=script&lang=js"
export * from "./ReviewCategoryTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports